module.exports = __webpack_public_path__ + "img/monaco.88700413.svg";